<template>
	<div>
		<template v-if="!loaded">
			<div
				style="width: 100%;height: 100%;position: absolute;display: flex;justify-content: center;align-items: center;">
				<loading />
			</div>
		</template>

		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-medium-size-100 md-size-50 md-small-size-100 md-xsmall-size-100">
				<div class="system-info">
					<div class="system-container">
						<div class="system-ministry">
							<img src="/logo.png" class="ministry-logo">
							<p class="ministry-khmer">ក្រសួងឧស្សាហកម្ម វិទ្យាសាស្ត្រ បច្ចេកវិទ្យា និងនវានុវត្តន៍
							</p>
							<p class="ministry-english">Ministry of Industry, Science, Technology & Innovation
							</p>
						</div>
						<div class="system-title">{{translate(locale.headTitle)}}</div>
					</div>
				</div>
			</div>
			<div class="md-layout-item md-medium-size-100 md-size-50 md-small-size-100 md-xsmall-size-100">
				<div class="system-feature">
					<div class="back-container" v-if="login_type != ''">
						<md-button class="md-primary md-just-icon md-simple" @click="goBack()"><i
								class="material-icons">arrow_back</i></md-button>
					</div>
					<div class="language-container">
						<md-button class="md-primary md-just-icon md-simple" @click="language(1)"><img src="/khmer.png"
								style="width: 32px;"></md-button>
						<md-button class="md-primary md-just-icon md-simple" @click="language(0)"><img
								src="/english.png" style="width: 32px;"></md-button>
					</div>

					<template v-if="loaded && authenticated && !expired">
						<div v-if="login_type == ''" style="width: 100%">
							<div class="welcome">
								<p class="welcome-title">{{translate(locale.welcome)}}</p>
								<p class="welcome-text">{{translate(locale.chooseMethod)}}</p>
							</div>
							<div class="method-list">
								<div class="method-container" @click="get_camdigikey_login_url()">
									<div class="method-icon"><img src="/camdigikey.png"></div>
									<div class="method-content">
										<p class="method-title">{{translate(locale.loginCamdigikey)}}</p>
										<p class="method-text">{{translate(locale.loginCamdigikeyText)}}</p>
									</div>
									<div class="method-arrow"></div>
								</div>
								<!-- <div class="method-container" @click="loginType('camdigikey')">
									<div class="method-icon"><img src="/camdigikey.png"></div>
									<div class="method-content">
										<p class="method-title">{{translate(locale.loginCamdigikey)}}</p>
										<p class="method-text">{{translate(locale.loginCamdigikeyText)}}</p>
									</div>
									<div class="method-arrow"></div>
								</div> -->
								<div class="method-container" @click="loginType('password')">
									<div class="method-icon"><img src="/login.jpg"></div>
									<div class="method-content">
										<p class="method-title">{{translate(locale.loginPassword)}}</p>
										<p class="method-text">{{translate(locale.loginPasswordText)}}</p>
									</div>
									<div class="method-arrow"></div>
								</div>
							</div>
						</div>

						<div v-if="login_type == 'password'" style="width: 100%">
							<template>
								<div class="welcome">
									<p class="welcome-title">{{translate(locale.loginPassword)}}</p>
									<p class="welcome-text">{{translate(locale.passwordPlease)}}</p>
								</div>
								<form @submit.prevent="login()" style="margin-top: 20px;">
									<div class="md-layout">
										<div class="md-layout-item md-small-size-100 md-size-100" style="padding: 0;">
											<md-field>
												<label>{{translate(locale.loginUser)}}</label>
												<md-input v-model="user.username" type="text"
													autocomplete="username"></md-input>
											</md-field>
										</div>
										<div class="md-layout-item md-small-size-100 md-size-100" style="padding: 0;">
											<md-field>
												<label>{{translate(locale.password)}}</label>
												<md-input v-model="user.password" type="password"
													autocomplete="current-password"></md-input>
											</md-field>
										</div>
										<div class="md-layout-item md-small-size-100 md-size-100" style="padding: 0;">
											<span style="color: red;">{{translate(fail_message)}}</span>
										</div>
										<div class="md-layout-item md-size-100 text-right" style="padding: 0;">
											<div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
												<a @click="change_password()" class="change-password-button">{{translate(locale.change_password)}}</a>
												<md-button class="md-raised md-primary" type="submit">{{translate(locale.login)}}</md-button>
											</div>
										</div>
									</div>
								</form>
							</template>
						</div>

						<div v-if="login_type == 'change-password'" style="width: 100%">
							<template v-if="change_password_new.token.length === 0">
								<div class="welcome">
									<p class="welcome-title">{{translate(locale.change_password)}}</p>
									<p class="welcome-text">{{translate(locale.changePasswordPlease)}}</p>
								</div>
								<form @submit.prevent="change_password_login()" style="margin-top: 20px;">
									<div class="md-layout">
										<div class="md-layout-item md-small-size-100 md-size-100" style="padding: 0;">
											<md-field>
												<label>{{translate(locale.loginUser)}}</label>
												<md-input v-model="change_password_user.username" type="text"
													autocomplete="username"></md-input>
											</md-field>
										</div>
										<div class="md-layout-item md-small-size-100 md-size-100" style="padding: 0;">
											<md-field>
												<label>{{translate(locale.password)}}</label>
												<md-input v-model="change_password_user.password" type="password"
													autocomplete="current-password"></md-input>
											</md-field>
										</div>
										<div class="md-layout-item md-small-size-100 md-size-100" style="padding: 0;">
											<span style="color: red;">{{translate(fail_message)}}</span>
										</div>
										<div class="md-layout-item md-size-100 text-right" style="padding: 0;">
											<md-button class="md-raised md-primary" type="submit">{{translate(locale.login)}}</md-button>
										</div>
									</div>
								</form>
							</template>
							<template v-else>
								<template v-if="!change_password_new.success">
									<div class="welcome">
										<p class="welcome-title">{{translate(locale.change_new_password)}}</p>
										<p class="welcome-text">{{translate(locale.change_new_password_please)}}</p>
									</div>
									<form @submit.prevent="change_password_set_new()" style="margin-top: 20px;">
										<div class="md-layout">
											<div class="md-layout-item md-small-size-100 md-size-100" style="padding: 0;">
												<md-field>
													<label>{{translate(locale.new_password)}}</label>
													<md-input v-model="change_password_new.new_password" type="password" autocomplete="current-password"></md-input>
												</md-field>
											</div>
											<div class="md-layout-item md-small-size-100 md-size-100" style="padding: 0;">
												<md-field>
													<label>{{translate(locale.confirm_password)}}</label>
													<md-input v-model="change_password_new.confirm_password" type="password" autocomplete="current-password"></md-input>
												</md-field>
											</div>
											<div class="md-layout-item md-small-size-100 md-size-100" style="padding: 0;">
												<span style="color: red;">{{translate(fail_message)}}</span>
											</div>
											<div class="md-layout-item md-size-100 text-right" style="padding: 0;">
												<md-button class="md-raised md-primary" type="submit">{{translate(locale.change_password_button)}}</md-button>
											</div>
										</div>
									</form>
								</template>
								<template v-else>
									<div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
										<i class="material-icons text-primary" style="font-size: 120px;">verified</i>
										<p style="margin-top: 30px; margin-bottom: 80px; font-size: 18px; font-weight: bold;">{{translate(locale.new_password_success)}}</p>
										<md-button class="md-raised md-primary" type="submit" @click="goBack()">{{translate(locale.login)}}</md-button>
									</div>	
								</template>
							</template>
						</div>

						<div v-if="login_type == 'camdigikey'" style="width: 100%">
							<div class="welcome" style="text-align: center !important;">
								<p class="welcome-title">{{translate(locale.loginCamdigikey)}}</p>
								<p class="welcome-text">{{translate(locale.camdigikeyPlease)}}</p>
							</div>
							<div style="text-align: center; color: red; margin-top: 40px;">
								{{translate(fail_message)}}</div>
							<div class="qr_image">
								<loading v-if="!camdigikeyLoaded && fail_message.length == 0" />
								<img style="width: 250px" v-if="camdigikeyLoaded":src="'data:image/png;base64,' + camdigikey.qr_image">
							</div>
							<!-- <div class="app-button show-mobile" style="width: 100%; text-align: center;margin: 15px 0">
								<md-button class="md-raised md-primary" @click="openApp()" v-if="camdigikey.auth_code != ''">Open CamDigiKey App</md-button>
							</div> -->
							<div class="instruction" style="font-size: 15px;">
								<p class="instruction-title"><b>{{translate(locale.instruction)}}</b></p>
								<ul>
									<li>{{translate(locale.camdigi1)}}<a href="https://play.google.com/store/apps/details?id=kh.gov.camdx.camdigikey" target="_blank">Android</a> {{translate(["or", "ឬ"])}} <a href="https://apps.apple.com/kh/app/camdigikey/id1509386989" target="_blank">iOS</a> {{translate(".||។")}}</li>
									<li>{{translate(locale.camdigi2)}}</li>
									<li>{{translate(locale.camdigi3)}}</li>
									<li>{{translate(locale.camdigi4)}}</li>
								</ul>
							</div>
						</div>
					</template>

					<template v-if="loaded && expired">
						<div
							style="display: flex;flex-direction: column; justify-content: center;align-items: center; padding: 40px 20px">
							<i class="material-icons" style="font-size: 80px; color: #f94984">gpp_bad</i>
							<p class="welcome-text" style="text-align: center;margin-bottom: 30px">{{translate(locale.loginExpired)}}<br>{{translate(locale.pleaseLoginAgain)}}</p>
							<p>
								<a :href="home_url">
									<md-button class="md-raised md-primary">{{translate(locale.goHome)}}</md-button>
								</a>
							</p>

						</div>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		created() {

			let token = this.$route.params.token;

			let decoded_token = this.config.base64decode(token);

			let checkToken = this.config.isJWT(decoded_token);

			if (checkToken.valid) {
				this.token = decoded_token;
				this.home_url = checkToken.data.home_url;

				this.$http.post(this.config.api + "/user/authenticate", {
					token: decoded_token
				}).then(data => {

					this.loaded = true;

					if (data.body.status === 'expired') this.expired = true;

					if (data.body.status == 'fail') this.$router.push("/404");

					if (data.body.status == 'success') {
						this.system_name = data.body.data.client_name;
						this.authenticated = true;
					}
				});

			} else {
				this.$router.push("/404");
			}
		},
		data() {
			return {
				token: "",
				system_name: "",
				home_url: "",
				loaded: false, // false
				expired: false, 
				authenticated: false, // false
				login_type: "", // ""
				fail_message: "",
				user: {
					username: "",
					password: ""
				},
				change_password_user: {
					username: "",
					password: ""
				},
				change_password_new: {
					token: "", // ""
					new_password: "",
					confirm_password: "",
					success: false //false
				},
				camdigikeyLoaded: false,
				pendingLogin: false,
				camdigikey: {
					hash: "",
					qr_image: "",
					auth_code: ""
				}
			}
		},
		methods: {
			login() {
				this.fail_message = "";
				if (this.pendingLogin) return;

				let username = this.user.username
				let password = this.user.password
				if (!this.checkValidation()) return;

				this.pendingLogin = true;
				this.$http.post(this.config.api + "/user/login_credential", { token: this.token, username, password }).then(res => {

					this.pendingLogin = false;

					if (res.body.status == 'expired') {
						this.expired = true;
						this.goBack();
					}

					if (res.body.status == 'fail') {
						this.fail_message = res.body.message;
					}

					if (res.body.status == 'success') {
						window.location.replace(res.body.data.redirect_url);
					}
				})
			},
			get_camdigikey_login_url() {
				this.$store.state.pending.is = true;
				this.$http.post(this.config.api + "/user/camdigikey_get_login_url", { token: this.token }).then(res => {

					if (res.body.status == 'expired') {
						this.expired = true;
						this.goBack();
					}

					if (res.body.status == 'fail') {
						this.fail_message = res.body.message;
						//alert notification
					}

					if (res.body.status == 'success') {
						this.$cookie.set('misti_single_id_login_token', this.$route.params.token, 1);
						window.location.replace(res.body.data.login_url);
					}

					this.$store.state.pending.is = false;
				})
			},
			getCamdigikey() {
				this.camdigikeyLoaded = false;

				this.$http.post(this.config.api + "/user/camdigikey_get_login", { token: this.token }).then(res => {

					if (res.body.status == 'expired') {
						this.expired = true;
						this.goBack();
					}

					if (res.body.status == 'fail') {
						this.fail_message = res.body.message;
					}

					if (res.body.status == 'success') {
						this.camdigikeyLoaded = true;
						this.camdigikey.hash = res.body.data.hash;
						this.camdigikey.qr_image = res.body.data.qr_image;
						this.camdigikey.auth_code = res.body.data.auth_code;
						this.verifyCamdigikey();
					}
				})
			},
			verifyCamdigikey() {
				setTimeout(() => {
					if (String(this.camdigikey.hash).length === 0) return;
					this.$http.post(this.config.api + "/user/camdigikey_verify_login", { token: this.token, hash: this.camdigikey.hash }).then(res => {

						if (res.body.status == 'expired') {
							this.expired = true;
							this.goBack();
						}

						if (res.body.status == 'fail') {
							this.fail_message = res.body.message;

							if(res.body.messageCode == 424) {
								setTimeout(() => {
									this.goBack();
								}, 4000)
							}
						}

						if (res.body.status == 'success') {
							if (res.body.data.redirect_url != undefined) {
								window.location.replace(res.body.data.redirect_url);
								return;
							}
							if (String(this.camdigikey.hash).length > 0) {
								this.verifyCamdigikey();
							}
						}
					})
				}, 5000)
			},
			change_password_login() {
				this.fail_message = "";
				if (this.pendingLogin) return;

				let username = this.change_password_user.username
				let password = this.change_password_user.password
				if (!this.checkValidationChangePassword()) return;

				this.pendingLogin = true;
				this.$http.post(this.config.api + "/user/change_credential_login", { token: this.token, username, password }).then(res => {

					this.pendingLogin = false;

					if (res.body.status == 'expired') {
						this.expired = true;
						this.goBack();
					}

					if (res.body.status == 'fail') {
						this.fail_message = res.body.message;
					}

					if (res.body.status == 'success') {
						this.change_password_new.token = res.body.data.change_password_token;
					}
				})
			},
			change_password_set_new() {
				this.fail_message = "";
				if (this.pendingLogin) return;

				let new_password = this.change_password_new.new_password
				if (!this.checkValidationNewPassword()) return;

				this.pendingLogin = true;
				this.$http.post(this.config.api + "/user/change_credential_new", { token: this.token, change_password_token: this.change_password_new.token, new_password }).then(res => {

					this.pendingLogin = false;

					if (res.body.status == 'expired') {
						this.expired = true;
						this.goBack();
					}

					if (res.body.status == 'fail') {
						this.fail_message = res.body.message;
					}

					if (res.body.status == 'success') {
						this.change_password_new.success = true;
					}
				})
			},
			openApp() {
				let auth_code = encodeURIComponent(this.camdigikey.auth_code);
				let name_en = encodeURIComponent("MISTI Single Identity");
				let name_km = encodeURIComponent("ប្រព័ន្ធគ្រប់គ្រងអត្តសញ្ញាណឌីជីថលតែមួយ");
				// let link = `camdigikey://login?token=${auth_code}&nameEn=${name_en}&nameKh=${name_km}`;
				let link = `camdigikey://sso_deeplink?qrCodeToken=${auth_code}&nameEn=${name_en}&nameKh=${name_km}`;
				window.location = link;
			},
			checkValidation() {

				if (String(this.user.username).length < 3 || String(this.user.password).length < 6) {
					this.fail_message = "Please fill in information!||សូមធ្វើបំពេញព័ត៌មាន !";
					return false;
				}

				return true;
			},
			checkValidationChangePassword() {
				if (String(this.change_password_user.username).length < 3 || String(this.change_password_user.password).length < 6) {
					this.fail_message = "Please fill in information!||សូមធ្វើបំពេញព័ត៌មាន !";
					return false;
				}

				return true;
			},
			checkValidationNewPassword() {
				if (String(this.change_password_new.new_password).length < 8) {
					this.fail_message = "Please fill in information and password must have length greater than 8 characters !||សូមធ្វើបំពេញព័ត៌មាន និងពាក្យសម្ងាត់ត្រូវមានលើសពី ៨ តួរអក្សរ !";
					return false;
				}
				if (this.change_password_new.new_password != this.change_password_new.confirm_password) {
					this.fail_message = "Confirm New Password is in correct!||បញ្ជាក់ពាក្យសម្ងាត់មិនត្រឹមត្រូវ។";
					return false;
				}

				return true;
			},
			loginType(type) {

				if (type == 'password') {
					this.user.username = "";
					this.user.password = "";
					this.fail_message = "";
				}

				if (type == 'camdigikey') {
					this.getCamdigikey();
				}

				this.login_type = type;
			},
			change_password() {
				this.login_type = "change-password";
				this.change_password_user.username = this.user.username;
			},
			goBack() {
				this.login_type = "";
				this.camdigikey.hash = "";
				this.camdigikey.qr_image = "";
				this.camdigikeyLoaded = false;
				this.fail_message = "";

				this.change_password_user.password = "";
				this.change_password_new.token = "";
				this.change_password_new.new_password = "";
				this.change_password_new.confirm_password = "";
				this.change_password_new.success = false;
			},
			language(code) {
				this.$store.state.l.lang = code;
				this.$cookie.set('lang', code, 10);
				window.document.title = this.translate(this.locale.headTitle);
			}
		}
	}
</script>

<style scoped>
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .1s
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0
	}
	.instruction-title {
		font-size: 16px;
	}
	.instruction > ul {
		list-style-type: none;
	}
	.instruction > ul > li {
		line-height: 28px;
	}
	.change-password-button {
		cursor: pointer;
	}
	.qr_image {
		margin: 40px 0;
		height: 250px;
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
	}

	.back-container {
		position: absolute;
		top: 15px;
		left: 15px;
	}

	.language-container {
		position: absolute;
		top: 18px;
		right: 18px;
	}

	.method-list {
		width: 100%;
		margin-top: 20px;
	}

	.method-container {
		cursor: pointer;
		width: 100%;
		margin-bottom: 20px;
		display: flex;
		border-radius: 6px;
		-webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
		box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
		border: 1px solid transparent;
		transition: 300ms;
	}

	.method-container:hover {
		border: 1px solid #00CCFF;
		background-color: #F5FEFF;
	}

	.method-icon {
		padding: 30px;
	}

	.method-content {
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding-right: 30px;
	}

	.method-title {
		font-weight: 800;
		margin-bottom: 2px;
		font-family: "Open Sans", "Kantumruy Pro", sans-serif;
	}

	.method-text {
		font-size: 14px;
		margin-bottom: 0;
	}

	.method-icon img {
		width: 50px;
		max-width: 50px;
		min-width: 50px;
	}

	.welcome {
		width: 100%;
		text-align: left;
	}

	.welcome-title {
		font-size: 28px;
		font-weight: 700;
		line-height: 38px;
		font-family: "Open Sans", "Kantumruy Pro", sans-serif;
	}

	.welcome-text {
		margin-top: 20px;
		font-size: 18px;
		line-height: 32px;
	}

	.system-feature {
		position: relative;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		min-height: 100vh;
		padding: 120px;
		padding-bottom: 220px;
		transition: 300ms;
	}

	.system-info {
		overflow: hidden;
		position: relative;
		margin: 0 -15px;
	}

	.system-container {
		background-image: url("/single_id.jpg");
		background-size: cover;
		background-position: center center;
		background-repeat: no-repeat;
		min-height: 100vh;
		background-attachment: scroll;
		padding: 40px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.system-title {
		font-family: "Open Sans", "Kantumruy Pro", sans-serif;
		text-align: center;
		color: #FFF;
		font-weight: 700;
		margin-top: 50px;
		margin-bottom: 100px;
		font-size: 26px;
	}

	.system-ministry {
		text-align: center;
	}

	.system-ministry p {
		color: #FFF;
		font-weight: 700;
		font-family: "Open Sans", "Kantumruy Pro", sans-serif;
	}

	.ministry-khmer {
		font-size: 18px;
	}

	.ministry-logo {
		margin-bottom: 20px;
		width: 100px;
	}

	.login-page {
		position: absolute;
		width: 100%;
		height: 100%;
	}

	@media (max-width: 1264px) {
		.method-text {
			font-size: 12px;
		}

		.system-container {
			min-height: 0;
			padding: 20px;
		}

		.system-feature {
			min-height: 0;
			padding-bottom: 20px;
			padding: 80px 15px 15px 15px;

		}

		.system-title {
			font-size: 20px;
			margin-top: 20px;
			margin-bottom: 20px;
		}

		.system-ministry p {
			color: #FFF;
			font-weight: 700;
			font-size: 12px;
			font-family: "Open Sans", "Kantumruy Pro", sans-serif;
		}

		.ministry-khmer {
			font-size: 14px !important;
		}

		.back-container {
			left: 0;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/Login.vue